import { deleteTenantOrganisation } from '@infuse/api/iam/tenant';
import { useGenericDeleteOrganisation } from '@infuse/iam/organisation/mutations';

export const useDeleteTenantOrganisation = () =>
  useGenericDeleteOrganisation({
    apiFn: deleteTenantOrganisation
  });
